// categorias.jsx
// autor: Walcledson de Paula / MVinfo
// data: 21/6/24 | 11h19
// data: 26/12/24 |17h30 | acrescentado ícone fisioterapeuta
// data: 25/10/25 |23h16 | modificado os ícones (imgs) para ícones do bootstrap (icons)
// ****************
// todos os direitos reservados. Proibida a cópia, reprodução e/ou utilização
// seu autorizão por escrita do autor.



// import IMGCategoria from '../../Assets/categoria/categoria';
import './categorias.css';

function Categorias() {
    const categorias = [
        { icon: "bi-person-rolodex", nome: "Salão de Beleza" },
        { icon: "bi-scissors", nome: "Barbearia" },
        { icon: "bi-person", nome: "Podóloga" },
        { icon: "bi-palette", nome: "Esmalteria" },
        { icon: "bi-person-workspace", nome: "Personal" },
        { icon: "bi-heart", nome: "Petshop" },
        { icon: "bi-cup-straw", nome: "Nutricionista" },
        { icon: "bi-heart-pulse", nome: "Estética / Emagrecimento" },
        { icon: "bi-person-standing", nome: "Pilates / Yoga" },
        { icon: "bi-droplet", nome: "Lavajato" },
        { icon: "bi-pen", nome: "Tatoo" },
        { icon: "bi-heart-pulse-fill", nome: "Médico" },
        { icon: "bi-heart-pulse", nome: "Dentista" },
        { icon: "bi-person-plus", nome: "Fisioterapeuta" }
    ];

    // console.log(categorias); // Para verificar se as imagens estão sendo importadas corretamente

    return (
        <section id="categorias">
            <div className="container">
                <div className="row">
                    <h1>São +13 Categorias disponíveis</h1>
                    <hr />
                    {/* {categorias.map((categoria, index) => (
                        <div className="col-6 col-md-4 col-lg-3 mb-4">
                            <div className="text-center p-3">
                                <div className="icon-circle bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2" style={{ width: '60px', height: '60px' }}>
                                    <i className={`bi ${categoria.icon} fs-2`}></i>
                                </div>
                                <h6>{categoria.nome}</h6>
                            </div>
                        </div>
                    ))} */}
                    {categorias.map((categoria, index) => (
                        <div 
                            key={index} 
                            className="col-12 col-sm-6 col-md-4 col-lg-4 categoria-item"
                        >
                            <div className="text-center p-3">
                                <div className="icon-circle bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2" style={{ width: '60px', height: '60px' }}>
                                    <i className={`bi ${categoria.icon} fs-2`}></i>
                                </div>
                                <h6>{categoria.nome}</h6>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Categorias;
